import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=2d8df4ae&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"
import style0 from "./MoreInfo.vue?vue&type=style&index=0&id=2d8df4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8df4ae",
  null
  
)

export default component.exports